import type { TrackingCallback } from "@pdfking/pdfengine"
import { Void } from "@pdfking/tfunc"
import tracking from "../state/tracking"

export default async <T>(
  provider: (emit: TrackingCallback) => Promise<T>,
  on_start: (emit: TrackingCallback) => void = Void,
  on_finish: (emit: TrackingCallback) => void = Void
): Promise<T> =>
  (tracking as any).track_promise(async (emit: TrackingCallback) => {
    void on_start(emit)
    const promise = await provider(emit)
    void on_finish(emit)
    return promise
  })
